import gql from 'graphql-tag';
import { MediaBaseFragment } from './MediaBaseFragment';

export const GeoIndicationFullFragment = gql`
	fragment GeoIndicationFullFragment on GeoIndication {
		id
		localId
		sfId
		name
		logoMedia {
			...MediaBaseFragment
		}
		status
		akas
		euIndication
		italianIndication
		descriptionValues
		description
		descriptionIta
		vatNumber
		website
		socialInstagramPage
		socialFacebookPage
		EuCategory {
			id
			name
		}
		Country {
			id
			name
		}
		StateProvince {
			id
			name
		}
		postalCode
		city
		address1
		address2
		lat
		lng
		goods {
			id
			name
		}
		companies {
			id
			name
		}
		managedByUsers {
			id
		}
		newsCitations {
			id
		}
	}
	${MediaBaseFragment}
`;
